import React from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from './../../../redux/hooks';

// Components 

import TextField from '@mui/material/TextField';

interface Props { 
    title?: string
}

const TeamMembersHeader: React.FC<Props> = ({title}) => {

  const colors = useAppSelector(state => state.theme.colors);  
  
  return (

      <Box sx={{ 
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: 50,
        width: '100%',
        paddingLeft: '1%',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        padding: '0 1vw',
        backgroundColor: colors?.listHeaderBackground,
        color: colors?.text, 
        fontSize: 14, 
    }}>

      <>

        <div style={{  width: '18%', marginLeft: '2%' }}>Team Member</div>

        <Box sx={{ width: '30%' }}>{'Referral Link'}</Box>

        <Box sx={{ width: '20%' }}>{'Email'}</Box>

        <Box sx={{ width: '15%' }}>{'Last Updated'}</Box>

        <Box sx={{ width: '10%' }}>Status</Box>

        <Box sx={{ width: '5%' }}>More</Box>

      </>


  </Box>

  );

};

export default TeamMembersHeader;